import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import './CreateForm.css';

const CreateForm = ({ type, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    description: '',
    meetingTime: '',
    maxMembers: type === 'studyGroups' ? 5 : 1,
    duration: type === 'tutoring' ? 60 : null,
    price: type === 'tutoring' ? '' : null,
    requirements: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <motion.div 
      className="create-form-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div 
        className="create-form"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <h2>Create {type === 'studyGroups' ? 'Study Group' : 'Tutoring Session'}</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">
              {type === 'studyGroups' ? 'Group Name' : 'Session Title'}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder={`Enter ${type === 'studyGroups' ? 'group' : 'session'} name`}
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="Enter subject"
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              placeholder="Describe the purpose and goals"
              rows="4"
            />
          </div>

          <div className="form-group">
            <label htmlFor="meetingTime">Meeting Time</label>
            <input
              type="datetime-local"
              id="meetingTime"
              name="meetingTime"
              value={formData.meetingTime}
              onChange={handleChange}
              required
            />
          </div>

          {type === 'studyGroups' && (
            <div className="form-group">
              <label htmlFor="maxMembers">Maximum Members</label>
              <input
                type="number"
                id="maxMembers"
                name="maxMembers"
                value={formData.maxMembers}
                onChange={handleChange}
                required
                min="2"
                max="20"
              />
            </div>
          )}

          {type === 'tutoring' && (
            <>
              <div className="form-group">
                <label htmlFor="duration">Duration (minutes)</label>
                <input
                  type="number"
                  id="duration"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  required
                  min="30"
                  max="180"
                  step="30"
                />
              </div>

              <div className="form-group">
                <label htmlFor="price">Price per Session ($)</label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                  min="0"
                  step="0.01"
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label htmlFor="requirements">Requirements</label>
            <textarea
              id="requirements"
              name="requirements"
              value={formData.requirements}
              onChange={handleChange}
              placeholder="List any prerequisites or requirements"
              rows="3"
            />
          </div>

          <button type="submit" className="submit-btn">
            Create {type === 'studyGroups' ? 'Study Group' : 'Tutoring Session'}
          </button>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default CreateForm; 